import * as React from "react";
import { Pencil2Icon } from "@radix-ui/react-icons";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { useCommonDialogs } from "../CommonDialogsProvider.tsx";
import { CardIconButton } from "./ItemActions.tsx";

interface Props {
  itemId: Id<"items">;
}

export const ItemNotesActionButton: React.FC<Props> = ({ itemId }) => {
  const dialogs = useCommonDialogs();
  return (
    <CardIconButton label="Notes" onClick={() => dialogs?.openItemNotesEditor({ itemId })}>
      <Pencil2Icon />
    </CardIconButton>
  );
};
